<template>
  <div class="components__cnt-table_milestones_mfa">
    <p></p>
    <table>
      <thead>
        <tr>
          <td>
            <p>
              <strong>Checkliste Aufgaben:</strong>
            </p>
            <p></p>
          </td>
          <td>
            <p>
              <strong>Erledigt</strong>
              <br />(Datum)
            </p>
          </td>
        </tr>
      </thead>
      <thead>
        <tr>
          <td colspan="2">
            <p>
              <strong>Im Vorfeld der Einstellung:</strong>
            </p>
          </td>
        </tr>
      </thead>
      <tbody>
       <tr><td><p>Vorstellung im Team </p></td><td></td></tr>
<tr><td><p>Zuweisung der anleitenden MFA</p></td><td></td></tr>
<tr><td><p>Überprüfung des Impfstatus </p></td><td></td></tr>
<tr><td><p>Jugendarbeitsschutzuntersuchung liegt vor</p></td><td></td></tr>
<tr><td><p>Besprechung des Bekleidungskodex</p></td><td></td></tr>
<tr><td><p>Erläuterung der Kommunikations- und Betriebskultur</p></td><td></td></tr>
<tr><td><p>Hinweis auf Berufsschulpflicht </p></td><td></td></tr>
<tr><td><p>Hinweis auf Methode der Krankmeldung in Berufschule und Praxis</p></td><td></td></tr>
<tr><td><p>Hinweis auf erwartete Eigeninitiative und Engagement </p></td><td></td></tr>
<tr><td><p>Besprechung der Schweigepflicht  (anhand von Beispielen)</p></td><td></td></tr>
<tr><td><p>Überreichung des Logbuch zur MFA-Ausbildung</p></td><td></td></tr>
      </tbody>
      <thead>
        <tr>
          <td colspan="2">
            <p>
              <strong>Erste Woche</strong> (bestenfalls an der Seite der ausbildenden MFA):
            </p>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr><td><p>Information „unsere neuen Azubis“ (Aushang oder digital – z.B. PraxisApp) erstellt</p></td><td><p></p></td></tr>
<tr><td><p>Räumlichkeiten gezeigt</p></td><td><p></p></td></tr>
<tr><td><p>Vorstellung im Team</p></td><td><p></p></td></tr>
<tr><td><p>Schweigepflichtserklärung und Datenschutzvereinbarung unterschrieben</p></td><td><p></p></td></tr>
<tr><td><p>Nutzung Logbuch zur MFA-Ausbildung erklärt</p></td><td><p></p></td></tr>
<tr><td><p>Tagesablauf der Praxis erläutert</p></td><td><p></p></td></tr>
<tr><td><p>Überblick zur Praxisorganisation (z.B. Teambesprechung, Urlaubsregel, Mitarbeitergespräche)</p></td><td><p></p></td></tr>
<tr><td><p>An Hygiene und Arbeitssicherheit herangeführt</p></td><td><p></p></td></tr>
<tr><td><p>Kommunikations- und Betriebskultur erklärt</p></td><td><p></p></td></tr>
<tr><td><p>Zur Eigeninitiative ermuntert</p></td><td><p></p></td></tr>
<tr><td><p>Rückspracheregeln vereinbart</p></td><td><p></p></td></tr>
<tr><td><p>Hinweis auf effizientes Arbeiten (z.B. was kann „zwischendrin“ erledigt werden)</p></td><td><p></p></td></tr>
<tr><td><p>Fehlerkultur erläutert (z.B. unmittelbare, wertschätzende Rückmeldung unter vier Augen)</p></td><td><p></p></td></tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="table-caption" colspan="2">
            <b>Tab. 1</b><br/>(<a
              target="_blank"
              rel="noopener noreferrer"
              href="/milestones_mfa.pdf"
              >als PDF zum Download</a
            >)
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<style lang="scss" scoped>
.components__cnt-table_milestones_mfa {
  @import "~stylesheets/frontend/specific/content-widgets_tables";
  table {
    max-width: 750px;
  }
}
</style>
